import loadScript from '@/utils/load-script';


export default async function () {
    // await loadScript('http://api.map.baidu.com/getscript?v=3.0&ak=vY6Rgi5RoBkL70jX2hrlpmrYbPUE7wfW&services=&t=20190424194839')
    await loadScript('//api.map.baidu.com/getscript?v=2.0&ak=YGujnTCh0ziobj4PuYIlICv4BQ0rrFW4&services=&t=20190527152033')
}
